// extracted by mini-css-extract-plugin
export default {"container":"styles_container__e9+ik","cards":"styles_cards__VWJtt"};